export const styles = [{
		"featureType": "all",
		"elementType": "geometry.fill",
		"stylers": [{
				"visibility": "on"
			},
			{
				"color": "#dad9d6"
			},
			{
				"gamma": "10.00"
			},
			{
				"saturation": "0"
			},
			{
				"lightness": "0"
			},
			{
				"weight": "1"
			}
		]
	},
	{
		"featureType": "administrative.province",
		"elementType": "geometry",
		"stylers": [{
				"visibility": "on"
			},
			{
				"color": "#000000"
			}
		]
	},
	{
		"featureType": "landscape",
		"elementType": "all",
		"stylers": [{
			"visibility": "off"
		}]
	},
	{
		"featureType": "landscape.natural",
		"elementType": "geometry.fill",
		"stylers": [{
				"visibility": "on"
			},
			{
				"color": "#ebebeb"
			}
		]
	},
	{
		"featureType": "landscape.natural.terrain",
		"elementType": "geometry.fill",
		"stylers": [{
				"visibility": "on"
			},
			{
				"color": "#e5e5e5"
			}
		]
	},
	{
		"featureType": "poi",
		"elementType": "all",
		"stylers": [{
			"visibility": "off"
		}]
	},
	{
		"featureType": "poi.attraction",
		"elementType": "geometry.fill",
		"stylers": [{
				"visibility": "on"
			},
			{
				"color": "#e2e1e1"
			}
		]
	},
	{
		"featureType": "poi.business",
		"elementType": "geometry.fill",
		"stylers": [{
				"visibility": "on"
			},
			{
				"color": "#e2e1e1"
			}
		]
	},
	{
		"featureType": "poi.government",
		"elementType": "geometry.fill",
		"stylers": [{
				"visibility": "on"
			},
			{
				"color": "#e2e1e1"
			}
		]
	},
	{
		"featureType": "poi.medical",
		"elementType": "geometry.fill",
		"stylers": [{
				"color": "#e2e1e1"
			},
			{
				"visibility": "on"
			}
		]
	},
	{
		"featureType": "poi.park",
		"elementType": "geometry.fill",
		"stylers": [{
				"visibility": "on"
			},
			{
				"color": "#9ed6c1"
			},
			{
				"saturation": "0"
			},
			{
				"weight": "1"
			},
			{
				"lightness": "48"
			}
		]
	},
	{
		"featureType": "poi.place_of_worship",
		"elementType": "geometry.fill",
		"stylers": [{
				"color": "#e2e1e1"
			},
			{
				"visibility": "on"
			}
		]
	},
	{
		"featureType": "poi.school",
		"elementType": "geometry.fill",
		"stylers": [{
				"visibility": "on"
			},
			{
				"color": "#e2e1e1"
			}
		]
	},
	{
		"featureType": "poi.sports_complex",
		"elementType": "geometry.fill",
		"stylers": [{
				"visibility": "on"
			},
			{
				"color": "#e2e1e1"
			}
		]
	},
	{
		"featureType": "road",
		"elementType": "all",
		"stylers": [{
				"saturation": -100
			},
			{
				"lightness": 45
			}
		]
	},
	{
		"featureType": "road.highway",
		"elementType": "all",
		"stylers": [{
			"visibility": "simplified"
		}]
	},
	{
		"featureType": "road.highway.controlled_access",
		"elementType": "geometry.fill",
		"stylers": [{
				"visibility": "on"
			},
			{
				"saturation": "100"
			},
			{
				"color": "#fcbbd7"
			}
		]
	},
	{
		"featureType": "road.highway.controlled_access",
		"elementType": "labels.icon",
		"stylers": [{
			"visibility": "off"
		}]
	},
	{
		"featureType": "road.arterial",
		"elementType": "geometry.fill",
		"stylers": [{
				"visibility": "on"
			},
			{
				"color": "#ffffff"
			}
		]
	},
	{
		"featureType": "road.arterial",
		"elementType": "labels.icon",
		"stylers": [{
			"visibility": "off"
		}]
	},
	{
		"featureType": "road.local",
		"elementType": "geometry.fill",
		"stylers": [{
				"visibility": "on"
			},
			{
				"color": "#ffffff"
			}
		]
	},
	{
		"featureType": "transit",
		"elementType": "geometry.fill",
		"stylers": [{
				"visibility": "on"
			},
			{
				"color": "#ffffff"
			}
		]
	},
	{
		"featureType": "transit",
		"elementType": "labels.text.fill",
		"stylers": [{
			"color": "#fbb6b6"
		}]
	},
	{
		"featureType": "transit",
		"elementType": "labels.icon",
		"stylers": [{
			"color": "#fbb6b6"
		}]
	},
	{
		"featureType": "transit.station.bus",
		"elementType": "geometry.fill",
		"stylers": [{
			"saturation": "100"
		}]
	},
	{
		"featureType": "water",
		"elementType": "all",
		"stylers": [{
				"color": "#568ea5"
			},
			{
				"visibility": "on"
			}
		]
	},
	{
		"featureType": "water",
		"elementType": "geometry.fill",
		"stylers": [{
			"color": "#99dcf5"
		}]
	},
	{
		"featureType": "water",
		"elementType": "labels.text.fill",
		"stylers": [{
				"color": "#2baedf"
			},
			{
				"visibility": "on"
			}
		]
	}
]

const markerColors = {
	butcher: {
		bg: '#deb817',
		color: '#000000',
	},
	kitchenrepublic: {
		bg: '#e0b150',
		color: '#ffffff',
	},
	missmiu: {
		bg: '#ff947f',
		color: '#ffffff',
	},
	negishi: {
		bg: '#e23810',
		color: '#ffffff',
	},
	nooch: {
		bg: '#e23810',
		color: '#ffffff',
	},
	outbacklodge: {
		bg: '#BE4D2E',
		color: '#ffffff',
	},
	fwgch: {
		bg: '#9ed6c1',
		color: '#403c3a',
	},
}

const homeMarkerColors = {
	butcher: {
		bg: '#deb817',
		color: '#000000',
	},
	kitchenrepublic: {
		bg: '#10918f',
		color: '#ffffff',
	},
	missmiu: {
		bg: '#783721',
		color: '#ffffff',
	},
	negishi: {
		bg: '#403C3A',
		color: '#ffffff',
	},
	nooch: {
		bg: '#403C3A',
		color: '#ffffff',
	},
	outbacklodge: {
		bg: '#000000',
		color: '#ffffff',
	},
	fwgch: {
		bg: '#403c3a',
		color: '#ffffff',
	},
}

const courierMarkerColors = {
	butcher: {
		bg: '#deb817',
		color: '#000000',
	},
	kitchenrepublic: {
		bg: '#2e162e',
		color: '#ffffff',
	},
	missmiu: {
		bg: '#f7b9ae',
		color: '#783721',
	},
	negishi: {
		bg: '#927E71',
		color: '#ffffff',
	},
	nooch: {
		bg: '#927E71',
		color: '#ffffff',
	},
	outbacklodge: {
		bg: '#E28E1D',
		color: '#ffffff',
	},
	fwgch: {
		bg: '#ffe66c',
		color: '#403c3a',
	},
}

export function getMarkerIcon(theme, { Size, Point } = google?.maps ?? {}, ) {
	return {
		url: `data:image/svg+xml;base64,${markerIcon(markerColors[theme]?.bg || 'black')}`,
		size: new Size(40, 54),
		origin: new Point(0, 0),
		labelOrigin: new Point(20, 20),
		anchor: new Point(20, 54),
		scaledSize: new Size(40, 54),
	}
}

export function getHomeIcon(theme, { Size, Point } = google?.maps ?? {}, ) {
	return {
		url: `data:image/svg+xml;base64,${homeIcon(homeMarkerColors[theme]?.bg, homeMarkerColors[theme]?.color)}`,
		size: new Size(50, 81),
		origin: new Point(0, 0),
		labelOrigin: new Point(25, 25),
		anchor: new Point(25, 81),
		scaledSize: new Size(50, 81),
	}
}

export function getCourierIcon(theme, { Size, Point } = google?.maps ?? {}, ) {
	return {
		url: `data:image/svg+xml;base64,${courierIcon(courierMarkerColors[theme]?.bg, courierMarkerColors[theme]?.color)}`,
		size: new Size(32, 32),
		origin: new Point(0, 0),
		labelOrigin: new Point(16, 16),
		anchor: new Point(16, 16),
		scaledSize: new Size(32, 32),
	}
}

export function getGeoIcon(theme, { Size, Point } = google?.maps ?? {}) {
	return {
		url: `data:image/svg+xml;base64,${geoIcon(markerColors[theme]?.bg || 'black')}`,
		size: new Size(48, 48),
		origin: new Point(0, 0),
		labelOrigin: new Point(24, 24),
		anchor: new Point(24, 24),
		scaledSize: new Size(48, 48),
	}
}

export function getMarkerLabel(theme) {
	return {
		color: markerColors[theme]?.color || 'white',
		fontSize: "15px",
		fontWeight: 'normal',
	}
}

function markerIcon(color = 'white') {
	return window.btoa(`
<svg width="40" height="55" viewBox="0 0 40 55" fill="${color}" xmlns="http://www.w3.org/2000/svg">
<path d="M20.0042 54.0029C21.9067 52.1311 32.233 38.9738 37.5755 29.0432L37.583 29.0288C37.5896 29.016 37.5961 29.0031 37.6041 28.9913C37.6132 28.9733 37.6231 28.9554 37.633 28.9378C37.6412 28.9231 37.6493 28.9085 37.6569 28.8939L37.6561 28.8914H37.6511C39.08 26.2564 39.879 23.3362 39.9873 20.3524C40.0956 17.3686 39.5104 14.3999 38.2761 11.6716C37.0418 8.94325 35.1909 6.52715 32.864 4.60673C30.5371 2.68641 27.7953 1.3122 24.8469 0.588656C21.8986 -0.134886 18.8211 -0.188832 15.8484 0.430944C12.8756 1.05062 10.0857 2.32781 7.69051 4.1654C5.29533 6.00309 3.35789 8.35277 2.02532 11.0361C0.692754 13.7194 0.000115248 16.6657 0 19.6515C0 19.6672 0 19.6828 0 19.6985C0.00391842 22.9052 0.810793 26.0621 2.34978 28.8906H2.34475L2.36495 28.9274C2.37601 28.9473 2.38729 28.9676 2.39761 28.9879C2.40769 29.0045 2.41692 29.0218 2.42615 29.0399C7.76951 38.9714 18.0958 52.1278 19.9991 54.0029H20.0042Z"/>
</svg>`)
}

function homeIcon(bg = 'black', color = 'white') {
	return window.btoa(`
<svg width="40" height="55" viewBox="0 0 40 55" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M20.0042 54.0029C21.9067 52.1311 32.233 38.9738 37.5755 29.0432L37.583 29.0288C37.5896 29.016 37.5961 29.0031 37.6041 28.9913C37.6132 28.9733 37.6231 28.9554 37.633 28.9378C37.6412 28.9231 37.6493 28.9085 37.6569 28.8939L37.6561 28.8914H37.6511C39.08 26.2564 39.879 23.3362 39.9873 20.3524C40.0956 17.3686 39.5104 14.3999 38.2761 11.6716C37.0418 8.94325 35.1909 6.52715 32.864 4.60673C30.5371 2.68641 27.7953 1.3122 24.8469 0.588656C21.8986 -0.134886 18.8211 -0.188832 15.8484 0.430944C12.8756 1.05062 10.0857 2.32781 7.69051 4.1654C5.29533 6.00309 3.35789 8.35277 2.02532 11.0361C0.692754 13.7194 0.000115248 16.6657 0 19.6515C0 19.6672 0 19.6828 0 19.6985C0.00391842 22.9052 0.810793 26.0621 2.34978 28.8906H2.34475L2.36495 28.9274C2.37601 28.9473 2.38729 28.9676 2.39761 28.9879C2.40769 29.0045 2.41692 29.0218 2.42615 29.0399C7.76951 38.9714 18.0958 52.1278 19.9991 54.0029H20.0042Z" fill="${bg}"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M19.5642 9.04284C19.8381 8.82346 20.2383 8.83916 20.4941 9.09012L31.5428 19.9339C31.8193 20.2054 31.8238 20.6496 31.5524 20.9262C31.2809 21.2027 30.8367 21.2065 30.5602 20.9351L28.2475 18.6656V28.2774C28.2475 28.6648 27.9333 28.979 27.5458 28.979H12.4542C12.0667 28.979 11.7526 28.6649 11.7526 28.2774V18.6663L9.43989 20.9351C9.1633 21.2064 8.71906 21.2027 8.44767 20.9262C8.17631 20.6495 8.18063 20.2046 8.45726 19.9333L19.5108 9.09012L19.5642 9.04284ZM13.1559 17.2896V27.5757H26.8441V17.2883L20.0014 10.5737L13.1559 17.2896Z" fill="${color}"/>
</svg>`)
}

function courierIcon(bg = 'black', color = 'white') {
	return window.btoa(`
<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="16" cy="16" r="16" fill="${bg}"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M11.712 9.40881C11.9203 9.42272 12.2458 9.45449 12.54 9.4853C12.9404 9.52724 13.373 9.57734 13.512 9.60199C13.7167 9.6383 13.9514 9.73287 14.1346 9.93811C14.3225 10.1487 14.4037 10.4173 14.4037 10.6991C14.4037 11.0393 14.2616 11.3151 14.0436 11.4959C13.8753 11.6353 13.6778 11.7052 13.5003 11.7226L13.7075 12.1865H18.0335L17.4042 10.803C17.3239 10.6261 17.3387 10.4203 17.4439 10.2569C17.5491 10.0936 17.7303 9.99456 17.9246 9.99451H20.1792C20.1859 9.99451 20.1926 9.99483 20.1993 9.99506C20.9242 10.0205 21.5063 10.6131 21.5063 11.3474C21.5063 12.0832 20.9037 12.7002 20.1535 12.7002C19.8378 12.7002 19.5819 12.4441 19.5817 12.1285C19.5818 11.8128 19.8378 11.5567 20.1535 11.5567C20.2652 11.5567 20.3628 11.4587 20.3629 11.3474C20.3628 11.2486 20.2948 11.165 20.2009 11.143L20.1591 11.138H18.8129L20.4611 14.7622C20.8159 14.659 21.1909 14.603 21.5789 14.603C23.7867 14.603 25.5766 16.393 25.5766 18.6007C25.5765 20.8085 23.7867 22.5985 21.5789 22.5985C19.3712 22.5984 17.5813 20.8085 17.5812 18.6007C17.5813 17.1883 18.3144 15.9472 19.4204 15.2362L18.8241 13.9258L17.0837 17.5567C17.3312 17.8273 17.4835 18.1867 17.4835 18.5823C17.4834 19.4229 16.802 20.1043 15.9615 20.1044C15.3232 20.1044 14.7773 19.7112 14.5511 19.1541H14.3797C14.1102 21.0998 12.441 22.5984 10.4211 22.5985C8.21331 22.5985 6.42345 20.8085 6.42337 18.6007C6.42345 16.393 8.2133 14.603 10.4211 14.603C10.8336 14.603 11.2315 14.6657 11.6059 14.7817L12.65 12.6237L12.2485 11.7237H11.5484C11.1683 11.7237 10.8972 11.4886 10.7533 11.3066C10.6252 11.1445 10.5144 10.9221 10.4886 10.6841L10.4831 10.5813L10.4892 10.473C10.519 10.2237 10.6452 9.99546 10.7622 9.8432C10.837 9.74595 10.9337 9.64568 11.0509 9.56514C11.1638 9.48761 11.3358 9.40155 11.5484 9.40155L11.712 9.40881ZM10.4211 15.7465C8.84483 15.7465 7.56692 17.0245 7.56685 18.6007C7.56693 20.177 8.84484 21.455 10.4211 21.455C11.8079 21.4549 12.9634 20.4654 13.2211 19.1541H10.4027C10.2058 19.1541 10.0226 19.0528 9.91801 18.8861C9.81353 18.7194 9.80222 18.5104 9.88786 18.3333L11.0995 15.828C10.882 15.775 10.6549 15.7465 10.4211 15.7465ZM21.5789 15.7465C21.3597 15.7465 21.1463 15.7717 20.9413 15.8185L22.0993 18.364C22.23 18.6514 22.103 18.9904 21.8157 19.1211C21.5283 19.2518 21.1893 19.1248 21.0586 18.8375L19.9006 16.292C19.1881 16.8109 18.7247 17.6519 18.7247 18.6007C18.7248 20.1769 20.0027 21.4549 21.5789 21.455C23.1552 21.455 24.4331 20.177 24.4332 18.6007C24.4331 17.0245 23.1552 15.7465 21.5789 15.7465ZM15.9615 18.2038C15.7828 18.2038 15.6333 18.3276 15.5935 18.4941C15.598 18.5228 15.6013 18.5524 15.6013 18.5823C15.6013 18.6119 15.5979 18.641 15.5935 18.6694C15.633 18.8364 15.7824 18.9609 15.9615 18.9609C16.1705 18.9608 16.34 18.7913 16.34 18.5823C16.34 18.3733 16.1705 18.2038 15.9615 18.2038ZM11.3144 18.0106H13.2139C13.0692 17.3222 12.6765 16.725 12.1335 16.3171L11.3144 18.0106ZM12.6382 15.2742C13.5564 15.8874 14.206 16.8705 14.3747 18.0106H14.5511C14.6212 17.8379 14.7222 17.6815 14.847 17.5472L13.2597 13.99L12.6382 15.2742ZM15.8844 17.0636C15.9099 17.0624 15.9357 17.0603 15.9615 17.0603C15.9919 17.0603 16.022 17.063 16.0519 17.0648L17.842 13.33H14.2178L15.8844 17.0636ZM11.6422 10.5802H11.9895C11.9419 10.5757 11.8962 10.5706 11.8532 10.5668C11.7791 10.5603 11.7142 10.555 11.6611 10.5512C11.6542 10.561 11.6476 10.5707 11.6422 10.5802Z" fill="${color}"/>
</svg>`)
}

function geoIcon(color = 'white') {
	return window.btoa(`
<svg width="40" height="40" viewBox="0 0 40 40" fill="${color}" xmlns="http://www.w3.org/2000/svg">
<circle cx="20" cy="20" r="20" fill-opacity="0.1"/>
<circle cx="20" cy="20" r="15" fill-opacity="0.2"/>
<circle cx="20" cy="20" r="10" fill-opacity="0.4"/>
<circle cx="20" cy="20" r="5"/>
</svg>`)
}
